import App from './App.svelte';
import './Katex.svelte';
var app = new App({
    target: document.body
});
/* var app = new Katex({
    target: document.body
    props: {
        math: 'x'
    }
}); */
export default app;
